import type { PayexThunkAction } from 'store/configureStore';

import { getCurrentLocale, isFetching } from 'selectors';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';

import { normalizeCountries } from 'services/countries/countries';

import {
  FETCH_COUNTRIES_FAILURE,
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_SUCCESS,
} from '../../../constants';

export const fetchCountries =
  (
    locale?: string,
  ): PayexThunkAction<Promise<void | { type: string; payload: unknown }>> =>
  async (dispatch, getState, { apiV3 }) => {
    const state = getState();

    const isFetchingCountries = isFetching(state, 'countries');
    if (isFetchingCountries) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_COUNTRIES_REQUEST,
    });

    try {
      const response = await apiV3.countries.fetch({
        locale: locale || getCurrentLocale(state),
      });
      return dispatch({
        type: FETCH_COUNTRIES_SUCCESS,
        payload: normalizeCountries(response),
      });
    } catch (error) {
      errorNotifier.notify(error);
      dispatch({ type: FETCH_COUNTRIES_FAILURE });
    }
  };
